import React from 'react';
import SessionDialData from '../../../../containers/sessionDetails/sessionDialData';

export const SurveyDial = props => {
  return <SessionDialData sessionId={props.sessionId} surveyId={props.surveyId} sessionName={props.sessionName} />;
};
